let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fNJPD")).then(() => parcelRequire('b8Z4e'));